import React, { useEffect } from 'react';
import { useState } from "react";
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    TextField
} from '@mui/material';
import dayjs from 'dayjs';
import { useHistory } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { EventNote } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import CircularProgressWithTimer from '../../components/CircularProgressWithTimer/CircularProgressWithTimer';
const EventVerification = (params) => {
    const INACTIVE_EVENT_MESSAGE = 'The previously selected event is no longer active. Please select another active event.';
    const data = params.location.state?.data;
    const history = useHistory();
    const [isCheckIn, setIsCheckIn] = React.useState(false);
    const userId = data?.users?.$values[0].id ?? data?.tempUserId ?? data?.userId;
    const existingUser = data?.users?.$values[0].existingUser ?? data?.existingUser ?? data?.existingUser;
    const [openProgressBar, setOpenProgressBar] = useState(false);
    const [error, setError] = useState(null);
    const [event, setEvent] = useState(null);
    const [counter, setCounter] = useState(5);
    let defaultEventId = localStorage.getItem('tempDefaultEventId') != '' &&
        localStorage.getItem('tempDefaultEventId') != 'undefined' &&
        localStorage.getItem('tempDefaultEventId') != null ?
        localStorage.getItem('tempDefaultEventId') :
        localStorage.getItem('defaultEventId');
    const roles = localStorage.getItem("roles") ? localStorage.getItem("roles")?.split(",") : [];

    const getCurrentEventId = () => {
        const tempEventId = localStorage.getItem('tempDefaultEventId');
        if (tempEventId && tempEventId !== 'undefined' && tempEventId.trim() !== "") {
            return tempEventId;
        }

        return localStorage.getItem('defaultEventId');
    };

    const redirectToNoEventIfInactive = () => {
        const currentDefaultEventId = localStorage.getItem('defaultEventId');
        if (!currentDefaultEventId || currentDefaultEventId.trim() === "") {
            localStorage.setItem('eventInactiveMessage', INACTIVE_EVENT_MESSAGE);
            history.push('/NoEvent');
            return true;
        }

        return false;
    };

    const validateEventIsActive = async () => {
        const selectedEventId = getCurrentEventId();
        if (!selectedEventId || selectedEventId.trim() === "") {
            localStorage.setItem('eventInactiveMessage', INACTIVE_EVENT_MESSAGE);
            history.push('/NoEvent');
            return false;
        }

        try {
            const response = await fetch(`/api/Event/GetEventById?id=${selectedEventId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            const eventEndDate = data?.events?.$values?.[0]?.eventEndDate;

            if (eventEndDate && dayjs(eventEndDate).isBefore(dayjs().startOf('day'))) {
                localStorage.setItem('defaultEventId', "");
                localStorage.setItem('tempDefaultEventId', "");
                localStorage.setItem('eventInactiveMessage', INACTIVE_EVENT_MESSAGE);
                history.push('/NoEvent');
                return false;
            }

            return true;
        } catch (ex) {
            setError("An error occurred, please try again later");
            return false;
        }
    };

    const handleCloseProgressBar = () => {
        setOpenProgressBar(false);
    };
    const handleFetchEvent = async () => {
        if (redirectToNoEventIfInactive()) {
            return;
        }

        setError(null);
        if (defaultEventId == null) {
            setError("No event found.");
        }
        else {
            setOpenProgressBar(true);
            try {
                fetch(`/api/Event/GetEventById?id=${defaultEventId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then((data) => {
                        if (JSON.stringify(data).length > 0) {
                            const selectedEvent = data?.events?.$values?.[0];
                            const eventEndDate = selectedEvent?.eventEndDate;

                            if (eventEndDate && dayjs(eventEndDate).isBefore(dayjs().startOf('day'))) {
                                localStorage.setItem('defaultEventId', "");
                                localStorage.setItem('eventInactiveMessage', INACTIVE_EVENT_MESSAGE);
                                history.push('/NoEvent');
                                setOpenProgressBar(false);
                                return;
                            }

                            setEvent({
                                EventId: selectedEvent?.eventId,
                                EventName: selectedEvent?.eventName,
                                EventDate: selectedEvent?.eventDate,
                                EventLocation: selectedEvent?.eventLocation,
                                EventClient: selectedEvent?.client,
                                EventNotes: selectedEvent?.note
                            });
                        }
                        else {
                            setError("No results found");
                        }
                        setOpenProgressBar(false);
                    })
                setOpenProgressBar(false);

            } catch (ex) {
                if (error.message.includes("No event")) {
                    setError("No event found.");
                }
                else if (error.message.includes("Unauthorized")) {
                    history.push('/noevent');
                }
                else {
                    setError("An error occurred, please try again later");
                }
                setOpenProgressBar(false);
            };
        }
    }
    const handleCheckIn = async () => {
        if (redirectToNoEventIfInactive()) {
            return;
        }

        const isEventActive = await validateEventIsActive();
        if (!isEventActive) {
            return;
        }

        const selectedEventId = getCurrentEventId();
        setOpenProgressBar(true);
        setError(null);
        let params = {
            "id": userId,
            "tempEventId": selectedEventId,
            "email": "",
            "lastName": "",
            "firstName": "",
            "phoneNumber": "",
            "existingUser": existingUser ?? false
        };
        // console.log(userId + " " + defaultEventId);
        const headers = {
            'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
            'Content-Type': 'application/json',
        }
        fetch(`/api/Adjuster/CheckIn`, {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(params)
        })
            .then(response => response.json())
            .then((response) => {
                if (roles?.length > 0 && roles?.find((role) => role?.toLowerCase().includes("checkinappadmin"))
                    && localStorage.getItem('tempDefaultEventId') != '' && localStorage.getItem('tempDefaultEventId') != 'undefined') {
                    history.push({ pathname: '/EventUserList', state: { id: localStorage.getItem('tempDefaultEventId') } });
                }
                else {
                    setIsCheckIn(true);
                    setOpenProgressBar(false);
                }
            })
            .catch(error => {
                if (error.message.includes("No user")) {
                    setError("No users found to check in.");
                }
                else if (error.message.includes("Unauthorized")) {
                    history.push('/noevent');
                }
                else {
                    setError("An error occurred, please try again later");
                }
                setOpenProgressBar(false);
            });
    }
    const handleHome = () => {
        if (redirectToNoEventIfInactive()) {
            return;
        }

        history.push("/");
    }
    useEffect(() => {
        if (redirectToNoEventIfInactive()) {
            return;
        }

        const fetchData = async () => {
            await handleFetchEvent();
        };
        fetchData();
    }, []);
    useEffect(() => {
        if (isCheckIn) {
            const countertimer = setInterval(() => {
                setCounter((prevCounter) => (prevCounter > 0 ? prevCounter - 1 : 0));
            }, 1000);
            const timer = setTimeout(() => {

                history.push("/");
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [isCheckIn, history]);
    return (
        <>
            <Grid container spacing={3} justifyContent="center">
                <Grid item xs={11}>
                    <div className="text-center space-y-2 w-full mx-auto max-w-screen-lg">
                        <div className="bg-white rounded-lg p-8 space-y-1 flex flex-col shadow-2xl">
                            <div className='space-y-8'>
                                {!isCheckIn ?
                                    <>
                                        <div className="text-center max-w-full mx-auto space-y-4 p-0">
                                            <p class="text-pink-800 font-bold mb-6">Please verify the details of the event, then select ‘Check In’ to finish the process</p>
                                        </div>
                                        <div class="border border-blue-900 rounded-lg p-6 mb-6 shadow-md">
                                            <h2 class="font-bold text-maroon-700">{event?.EventName}</h2>
                                            <p class="text-maroon-700">{dayjs(event?.EventDate?.$d).format('MM-DD-YYYY')}</p>
                                            <p class="text-maroon-700">{event?.EventLocation}</p>
                                            <p class="text-maroon-700">{event?.EventClient}</p>

                                            {error &&
                                                <div class="flex justify-center py-2">
                                                    <div className="text-red-500">{error}</div>
                                                </div>
                                            }
                                        </div>
                                        <button className="bg-red-900 text-white rounded-full px-16 py-2" onClick={handleCheckIn}>Check In</button>
                                    </>
                                    :
                                    <>
                                        <div class="p-6 mb-6">
                                            <p class="font-bold text-maroon-900">
                                                <Typography variant="h6" className='text-black-500'>Thank you!</Typography></p>
                                        </div>
                                        <Typography variant="h4" className='text-green-500'>Successfully Checked In!</Typography>
                                        {/* <CircularProgressWithTimer></CircularProgressWithTimer> */}
                                        <div class="p-2 mb-1">
                                            <p class="font-bold text-maroon-900">
                                                <Typography variant="h8" className='text-black-500'>Back to home in {` ${counter} seconds`}!</Typography></p>
                                        </div>
                                    </>
                                }
                            </div>

                        </div>

                    </div>                   
                </Grid>
            </Grid >
            <Backdrop
                open={openProgressBar}
                onClick={handleCloseProgressBar}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default EventVerification;